<!-- Sign Up -->
<section>
    <div class="container content-box">

        <!-- Form -->
        <form name="form" (submit)="f.form.valid && onSubmit()" #f="ngForm" novalidate>

            <!-- Header -->
            <h1 class="text-center">Sign Up</h1>
            <p class="text-center no-margin">Fill in this form and click "Next" to continue to the next page.</p>
            <p class="text-center"><small>$30 + processing fees to those with addresses outside of Nebraska.</small></p>
            <hr>

            <!-- Input Fields -->
            <div class="col-md-12">

                <!-- Input Row -->
                <div class="row mt-2">

                    <!-- Email -->
                    <div class="col-md-12">
                        <label class="required-field">Email</label>
                        <input type="email" id="email" class="form-control mb-2" placeholder="Email" [(ngModel)]="user.email" #email="ngModel" name="email" [ngClass]="{ 'is-invalid': f.submitted && email.invalid }" email required>

                        <!-- Invalid Email-->
                        <div *ngIf="f.submitted && email.invalid" class="invalid-feedback">
                            <div class="mb-1 text-center" *ngIf="email.errors!.required">Email is required</div>
                            <div class="mb-1 text-center" *ngIf="email.errors!.email">Email must be a valid email address</div>
                        </div>
                    </div>
                </div>

                <!-- Input Row-->
                <div class="row mt-2">

                    <!-- Password -->
                    <div class="col-md-12">
                        <label class="required-field">Password</label>
                        <input (focus)="onPasswordChange($event)" type="password" id="password" class="form-control mb-2" placeholder="Password" [(ngModel)]="user.password" name="password" #password="ngModel" [ngClass]="{ 'is-invalid': f.submitted && password.invalid }" password required minlength="6">

                        <!-- Invalid Password -->
                        <div *ngIf="f.submitted && password.invalid" class="invalid-feedback">
                            <div class="mb-1 text-center" *ngIf="password.errors!.required">Password is required</div>
                            <div class="mb-1 text-center" *ngIf="password.errors!.minlength">Password must be at least 6 characters</div>
                        </div>
                    </div>
                </div>

                <!-- Input Row-->
                <div class="row mt-2">

                    <!-- Confirm Password -->
                    <div class="col-md-12">
                        <label class="required-field">Confirm Password</label>
                        <input type="password" id="confirmPassword" class="form-control mb-2" placeholder="Confirm Password" [(ngModel)]="user.confirmPassword" name="confirmPassword" #confirmPassword="ngModel" [ngClass]="{ 'is-invalid': f.submitted && confirmPassword.invalid }"
                            password required validateEqual="password" minlength="6">

                        <!-- Invalid Confirm Password -->
                        <div *ngIf="f.submitted && confirmPassword.invalid" class="invalid-feedback">
                            <div class="mb-1 text-center" *ngIf="confirmPassword.errors!.required">Confirmed Password is required</div>
                            <div class="mb-1 text-center" *ngIf="confirmPassword.errors!.minlength">Confirm Password must be at least 6 characters</div>
                            <div class="mb-1 text-center" *ngIf="password.value !== confirmPassword.value">Password and Confirm Password need to match</div>
                        </div>
                    </div>
                </div>

                <!-- Input Row -->
                <div class="row mt-2">

                  <!-- Are you under the age of 18? -->
                  <div class="col-md-12 check">
                    <label for="ageUnder18" class="required-field form-check-label">Are you under the age of 18?</label>
                    <input type="hidden" [(ngModel)]="user.ageUnder18" #ageUnder18="ngModel" class="form-control" name="ageUnder18" required>

                    <!-- Yes or No -->
                    <div class="input-group" [ngClass]="{ 'is-invalid': f.submitted && ageUnder18.invalid }">
                      <button class="btn custom" type="button" [ngClass]="[user.ageUnder18 === true ? 'btn-primary' : 'btn-outline-primary']" (click)="user.ageUnder18 = true">Yes</button>
                      <button class="btn custom" type="button" [ngClass]="[user.ageUnder18 === false ? 'btn-primary' : 'btn-outline-primary']" (click)="user.ageUnder18 = false">No</button>
                    </div>

                    <!-- Invalid -->
                    <div *ngIf="f.submitted && ageUnder18.invalid" class="invalid-feedback">
                      <div class="mb-1" *ngIf="ageUnder18.errors!.required">Please select Yes or No</div>
                    </div>
                  </div>
              </div>
            </div>

            <!-- Next page button -->
            <div class="text-center">
                <button type="submit" class="my-4 btn">Next</button>
            </div>

            <!-- Login Link-->
            <p class="mb-4 text-center">Already have an account?
                <a [routerLink]="'/login'">Login</a>
            </p>
        </form>
    </div>
</section>
